<div class="container-fluid color-primario-fondo h-100">
    <div class="row justify-content-center text-center">
        <div class="col-sm-12 col-md-9">
            <div class="card shadow-primario mt-4">
                <div class="card-header">
                    <div class="row align-items-center">
                        <div class="col-sm-12 col-md-6 text-center py-2">
                            <img src="assets/logotipos/universidad-surcolombiana-normal-horizontal-b.png"
                                alt="universidad-surcolombiana-vertical-l.png" width="75%">
                        </div>
                        <div class="col-sm-12 col-md-6 text-center color-primario-letra py-2">
                            <h1>{{titulo}}</h1>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <!-- Login  -->
                    <form (ngSubmit)="onSubmitValidarCredenciales($event)" *ngIf="!esTokenValido" [formGroup]="formulario">
                        <div class="row justify-content-center">
                            <div class="col-sm-12 col-md-7">
                                <div class="form-floating my-5">
                                    <input type="text"
                                        [class]="(getUsuario()?.valid ? 'form-control is-valid':'form-control is-invalid')"
                                        formControlName="usuario" id="usuario" placeholder="Usuario"
                                        autocomplete="username" required>
                                    <label for="usuario"><i class="bi bi-person-square mx-3"></i>Usuario</label>
                                    <div *ngIf="getUsuario()?.hasError('required')" class="invalid-feedback">
                                        El usuario es requerido
                                    </div>
                                </div>
                                <div class="form-floating mb-5">
                                    <input type="password"
                                        [class]="(getContrasena()?.valid ? 'form-control is-valid':'form-control is-invalid')"
                                        formControlName="contrasena" id="contrasena" placeholder="Contraseña"
                                        autocomplete="current-password"  required>
                                    <label for="contrasena"><i class="bi bi-key-fill mx-3"></i>Contraseña</label>
                                    <div *ngIf="getContrasena()?.hasError('required')" class="invalid-feedback">
                                        La contraseña es requerida
                                    </div>                                    
                                </div>

                                <div style="margin-bottom: 30px;"><a _ngcontent-iqw-c35="" href="https://www.usco.edu.co/cambio_clave/" target="_blank"><small _ngcontent-iqw-c35="" class="font-usco-vt font-weight-bold">¿Olvidó su contraseña?</small></a> &nbsp;&nbsp; | &nbsp;&nbsp; <a _ngcontent-iqw-c35="" href="https://gaitana.usco.edu.co/graduado_web/" target="_blank"><small _ngcontent-iqw-c35="" class="font-usco-vt font-weight-bold">Ingreso sistema graduados</small></a></div>
                                

                                <button type="submit" class="btn btn-primary color-primario-fondo text-white mb-4 " *ngIf="formulario.valid">Validar</button>
                            </div>
                        </div>
                    </form>
                    <!-- Token  -->
                    <form (ngSubmit)="onSubmitValidarTokenInicioSesionYAutenticar($event)" *ngIf="esTokenValido" [formGroup]="formToken">
                        <div class="row justify-content-center">
                            <div class="col-sm-12 col-md-7">
                                <div class="form-floating mb-5">
                                    <input type="text"
                                        [class]="(getToken()?.valid ? 'form-control is-valid':'form-control is-invalid')"
                                        formControlName="token" id="token" placeholder="Token" [required]="esTokenValido">
                                    <label for="token"><i class="bi bi-key-fill mx-3"></i>Código de verificación</label>
                                    <div *ngIf="getToken()?.hasError('required')" class="invalid-feedback">
                                        El código de verificación es requerido
                                    </div>
                                </div>
                                <button type="submit" class="btn btn-primary color-primario-fondo text-white mb-4 " *ngIf="formToken.valid && formulario.valid">Validar</button>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="card-footer">
                    <h5>{{version}}</h5>
                </div>
            </div>
        </div>
    </div>
</div>